import { classImplementsInterfaces } from "@goodgamestudios/createjs-utilities";
import { AbstractTeaser } from "./common/AbstractTeaser";
import { TeaserTextsVO } from "./common/TeaserTextsVO";
import { TeaserVO } from "./common/TeaserVO";

import MovieClip = createjs.MovieClip;

export class HalloweenTeaser extends AbstractTeaser {
    protected _btnShop: MovieClip;
    protected _btnOk: MovieClip;

    constructor(featureId: number, teaserMc: MovieClip, teaserVO: TeaserVO) {
        super(featureId, teaserMc, teaserVO);
    }

    protected buildHook(): void {
        this._btnShop = this._teaserMc.btn_shop;
        this._btnOk = this._teaserMc.btn_ok;
    }

    public fillButtonLabels(vo: TeaserTextsVO = null): void {
        var textVO: TeaserTextsVO = (vo == null) ? this._teaserVO.teaserTextsVO : vo;

        this._btnShop.label = textVO.btnShopLabel;
        this._btnOk.label = textVO.btnOkLabel;
    }
}
classImplementsInterfaces(HalloweenTeaser, "Container");
